module.exports = __webpack_public_path__ + "img/atm.89ecf61e.svg";